import moment from "moment";

export const formatDateString = dateString => {
  try {
    return moment(dateString).format("YYYY-MM-DD HH:mm:ss");
  } catch (ex) {
    return dateString;
  }
};

export const formatDateTimeString = dateString => {
  //Agregar moment para dar formato a hora y fecha
  try {
    let datetime = moment(dateString).format("YYYY-MM-DD HH:mm:ss");
    return datetime.split(" ");
  } catch (ex) {
    return [dateString, ""];
  }
};

export const sortDateString = (a, b, desc) => {
  // force null and undefined to the bottom
  a = a === null || a === undefined ? -Infinity : a;
  b = b === null || b === undefined ? -Infinity : b;
  // force any string values to lowercase
  a = a === "string" ? a.toLowerCase() : a;
  b = b === "string" ? b.toLowerCase() : b;

  if (typeof a === "string" && typeof b === "string") {
    if (a.length !== b.length) {
      return a.length > b.length ? 1 : -1;
    }
  }

  // Return either 1 or -1 to indicate a sort priority
  if (a > b) {
    return 1;
  }
  if (a < b) {
    return -1;
  }
  // returning 0, undefined or any falsey value will use subsequent sorts or the index as a tiebreaker
  return 0;
};

export const getTodayDates = () => {
  return {
    startDate: moment().startOf("day"),
    //endDate: moment().endOf("day") // Actual end of day
    endDate: moment() // Avoids to query for more than the current time
  };
};

export const getYesterdayDates = () => {
  return {
    startDate: moment()
      .subtract(1, "day")
      .startOf("day"),
    endDate: moment()
      .subtract(1, "day")
      .endOf("day")
  };
};

export const getCurrentWeekDates = () => {
  return {
    startDate: moment().startOf("week"),
    //endDate: moment().endOf("week") // Actual end of week
    endDate: moment() // Avoids to query for more than the current time
  };
};

export const getLast30DaysDates = () => {
  return {
    startDate: moment().subtract(30, "days"),
    endDate: moment()
  };
};

export const getPreviousMonthDates = () => {
  return {
    startDate: moment()
      .subtract(1, "month")
      .startOf("month"),
    endDate: moment()
      .subtract(1, "month")
      .endOf("month")
  };
};

export const getMonthBeforePreviousMonthDates = () => {
  return {
    startDate: moment()
      .subtract(2, "month")
      .startOf("month"),
    endDate: moment()
      .subtract(2, "month")
      .endOf("month")
  };
};

export const getPast2MonthsIndexes = () => {
  return {
    pastMonth:
      moment()
        .subtract(1, "month")
        .month() + 1,
    beforePastMonth:
      moment()
        .subtract(2, "month")
        .month() + 1
  };
};



// WEBPACK FOOTER //
// ./src/utilities/datesFormatter.js